import { create } from "zustand";
import { newSession, deleteSession } from "../api";

interface SessionState {
  sessionId: string | null;
  initSession: () => Promise<void>;
  resetSession: () => Promise<void>;
}

export const useSessionStore = create<SessionState>((set, get) => ({
  sessionId: null,

  initSession: async () => {
    const stored = sessionStorage.getItem("scoutdex_session_id");
    if (stored) {
      set({ sessionId: stored });
    } else {
      const id = await newSession();
      sessionStorage.setItem("scoutdex_session_id", id);
      set({ sessionId: id });
    }
  },

  resetSession: async () => {
    const { sessionId } = get();
    if (sessionId) {
      await deleteSession(sessionId).catch(() => undefined);
    }
    const id = await newSession();
    sessionStorage.setItem("scoutdex_session_id", id);
    set({ sessionId: id });
  },
}));
